import React from 'react';
import classNames from 'classnames';
import { useCustomTranslation } from '../Hooks/useCustomTranslation/useCustomTranslation.js';
import { PasswordStrength, getPasswordStrength } from '../../../helpers/password/getPasswordStrength.js';
import styles from './PasswordStrengthBar.scss.js';

const PasswordStrengthBar = _ref => {
  let {
    password = ''
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  const passwordStrengthScores = {
    [PasswordStrength.WEAK]: tCustom('PASSWORDSTRENGTHBAR_WEAK_TEXT'),
    [PasswordStrength.MEDIUM]: tCustom('PASSWORDSTRENGTHBAR_MEDIUM_TEXT'),
    [PasswordStrength.STRONG]: tCustom('PASSWORDSTRENGTHBAR_STRONG_TEXT'),
    [PasswordStrength.VERY_STRONG]: tCustom('PASSWORDSTRENGTHBAR_VERYSTRONG_TEXT')
  };
  const passwordStrength = getPasswordStrength(password);
  const passwordStrengthText = passwordStrengthScores[passwordStrength];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.container]: true,
      [styles['container--weak']]: passwordStrength === PasswordStrength.WEAK,
      [styles['container--medium']]: passwordStrength === PasswordStrength.MEDIUM,
      [styles['container--strong']]: passwordStrength === PasswordStrength.STRONG || passwordStrength === PasswordStrength.VERY_STRONG
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container__label
  }, /*#__PURE__*/React.createElement("span", null, tCustom('PASSWORDSTRENGTHBAR_TITLE'), /*#__PURE__*/React.createElement("span", {
    className: styles.container__label__color
  }, " ", passwordStrengthText))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.container__bar]: true,
      [styles['container__bar--position-1']]: true,
      [styles['container__bar--enabled']]: passwordStrength >= PasswordStrength.WEAK
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.container__bar]: true,
      [styles['container__bar--position-2']]: true,
      [styles['container__bar--enabled']]: passwordStrength >= PasswordStrength.MEDIUM
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.container__bar]: true,
      [styles['container__bar--position-3']]: true,
      [styles['container__bar--enabled']]: passwordStrength >= PasswordStrength.STRONG
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.container__bar]: true,
      [styles['container__bar--position-4']]: true,
      [styles['container__bar--enabled']]: passwordStrength >= PasswordStrength.VERY_STRONG
    })
  }));
};
var PasswordStrengthBar$1 = PasswordStrengthBar;

export { PasswordStrengthBar$1 as default };
//# sourceMappingURL=PasswordStrengthBar.js.map
